<template>
  <div style="width: 100%">
    <q-select
      v-model="model"
      use-input
      input-debounce="0"
      label=""
      option-label="number"
      option-value="id"
      :emit-value="true"
      map-options
      :loading="dataLoading"
      :options="options"
      @filter="filterFn"
      @input="$emit('changed', model)"
      style="width: 100%"
    >
      <template
        v-slot:option="{ itemProps, opt, selected, toggleOption, itemEvents }"
      >
        <q-item v-bind="itemProps" v-on="itemEvents">
          <q-item-section @click="toggleOption(opt)">
            <q-item-label>
              {{ opt.number }}
            </q-item-label>
            <q-item-label
              caption
              style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              "
              >{{ opt.description }}</q-item-label
            >

            <q-tooltip>
              <p class="q-my-xs" style="font-size: 14px; width: 600px">
                {{ opt.description }}
              </p>
            </q-tooltip>
          </q-item-section>
          <!-- <q-item-section avatar>
            <q-btn @click.prevent flat icon="mdi-eye" round size="sm">
              <q-menu>
                <div
                  class="row no-wrap q-pa-md full-width"
                  style="min-width: 500px"
                >
                  <div class="column full-width">
                    <div class="text-h6 q-mb-md">{{ opt.number }}</div>
                    <p>{{ opt.description }}</p>
                  </div>
                </div>
              </q-menu>
            </q-btn>
          </q-item-section> -->
        </q-item>
      </template>
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-grey"> No results </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    props: {
      id: {
        type: Number,
        default: null,
      },
      currentDQ: {
        type: String,
        default: null,
      },
      discipline_id: {
        default: null,
      },
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        siteCFG: "settings/siteCFG",
        data: "dqCodes/list",
        dataLoading: "dqCodes/listLoading",
      }),
    },
    watch: {
      id: function () {
        this.init();
      },
      dqCodes: function () {
        this.init();
      },
    },
    data: () => ({
      model: null,
      options: [],
    }),
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.options = JSON.parse(
          JSON.stringify(
            this.data.filter((e) =>
            {

              return  this.discipline_id && e.disciplines_id
              ? e.disciplines_id.split(",").includes(this.discipline_id)
              : true
            }

            )
          )
        );
        this.model = this.id;
      },
      filterFn(val, update) {
        if (val === "") {
          update(() => {
            this.options = JSON.parse(
              JSON.stringify(
                this.data.filter((dqCode) => {
                  if (this.currentDQ) {
                    return dqCode.code == this.currentDQ;
                  } else {
                    return true;
                  }
                })
              )
            );
          });
          return;
        } else {
          update(() => {
            const needle = val.toLowerCase();
            this.options = this.data.filter((v) => {
              let dqCodeFilter = false;
              if (this.currentDQ) {
                dqCodeFilter = v.code == this.currentDQ;
              } else {
                dqCodeFilter = true;
              }
              let textSearch =
                v.discipline_name.toLowerCase().indexOf(needle) > -1;

              let discipline_idFilter = this.discipline_id
                ? v.disciplines_id.split(",").includes(this.discipline_id)
                : true;
              return textSearch && dqCodeFilter && discipline_idFilter;
            });
          });
        }
      },
    },
  };
</script>
